import { render, staticRenderFns } from "./SmartFeedV3.vue?vue&type=template&id=4dba512c&scoped=true&"
import script from "./SmartFeedV3.vue?vue&type=script&lang=js&"
export * from "./SmartFeedV3.vue?vue&type=script&lang=js&"
import style0 from "./SmartFeedV3.vue?vue&type=style&index=0&id=4dba512c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba512c",
  null
  
)

export default component.exports